import { render, staticRenderFns } from "./AdminPortal.vue?vue&type=template&id=34492c60&"
import script from "./AdminPortal.vue?vue&type=script&lang=ts&"
export * from "./AdminPortal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports